import { useEffect } from 'react';
import { fetchDealById, fetchLeadById } from '../services/zohoAPI';
import { withKey, API_BASE, resolveProductHidden } from '../services/utils';

export function useZohoLookups({ setOffer, normalizeLoadedOffer }) {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const clientId = params.get('client_id');
    if (!clientId) return;

    const loadLead = async () => {
      const lead = await fetchLeadById(clientId);
      if (!lead) return;
      setOffer(prev => ({
        ...prev,
        client_name: lead.name,
        client_email: lead.email,
        client_id: lead.id
      }));
    };
    loadLead();
  }, [setOffer]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const dealId = params.get('deal_id');
    if (!dealId) return;

    const loadDeal = async () => {
      const deal = await fetchDealById(dealId);
      if (!deal) return;
      setOffer(prev => ({
        ...prev,
        deal_id: deal.id,
        deal_name: deal.name
      }));
    };
    loadDeal();
  }, [setOffer]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const zohoOfferId = params.get('offer_id');
    if (!zohoOfferId) return;

    const loadOfferFromZoho = async () => {
      try {
        const response = await fetch(await withKey(`${API_BASE}/api/zoho/offers/${zohoOfferId}`));
        const data = await response.json();
        if (data?.error) {
          console.error(`Error loading offer from Zoho: ${data.error}`);
          alert(`Failed to load offer: ${data.error}`);
          return;
        }
        const normalized = normalizeLoadedOffer(data);
        normalized.items = await resolveProductHidden(normalized.items);
        setOffer(normalized);
      } catch (error) {
        console.error('Error loading offer from Zoho:', error);
        alert('Failed to load offer from Zoho');
      }
    };
    loadOfferFromZoho();
  }, [normalizeLoadedOffer, setOffer]);
}
